import { useDispatch, useSelector } from "react-redux";
import { basicModalShowHide } from "../../features/modalSlice.js";
import { deleteHuntPack, setDeleteHuntPackId } from "../../features/huntPackSlice.js";
import { errorToastify } from "../../utils/toastify.util.js";

const HuntPackDelete = () => {
  const dispatch = useDispatch();
  const { deleteHuntPackId } = useSelector((state) => state.huntPack);

  const handleDelete = () => {
    try {
      dispatch(deleteHuntPack({ id: deleteHuntPackId }));
      dispatch(basicModalShowHide());
    } catch (err) {
      errorToastify(err.message);
    }
  };

  const handleCancel = () => {
    dispatch(setDeleteHuntPackId(null));
    dispatch(basicModalShowHide());
  };

  return (
    <>
      <div>
        <h5>Are you sure you want to delete this hunt pack?</h5>
      </div>
      <div className="float-end">
        <button type="button" className="btn btn-secondary me-2" onClick={handleCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger" onClick={handleDelete}>
          Delete
        </button>
      </div>
    </>
  );
};

export default HuntPackDelete;
